import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";

import { HttpclientService } from "../../../../shared";
import { Subject } from "rxjs";
import { FineTypeInsertRequest } from "./FineTypeInsertRequest";
import { FineTypeUpdateRequest } from "./FineTypeUpdateRequest";
import { FineTypeInUseRequest } from "./FineTypeInUseRequest";

@Injectable()
export class DataService_FineTypeSetup {
	constructor(private http: HttpClient, private httpclientService: HttpclientService) {}

	//INSERT CUSTOM METHODS HERE
	LoadFineType(SchoolID) {
		var postResult$ = new Subject();
		var url = "SchoolSetupCalendar/LoadFineType?SchoolID=" + SchoolID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	FineTypeInsert(parms: FineTypeInsertRequest) {
		var postResult$ = new Subject();
		var url = "SchoolSetupCalendar/FineTypeInsert";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	FineTypeUpdate(parms: FineTypeUpdateRequest) {
		var postResult$ = new Subject();
		var url = "SchoolSetupCalendar/FineTypeUpdate";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	FineTypeDelete(AccountDebitTypeID) {
		var postResult$ = new Subject();
		var url = "SchoolSetupCalendar/FineTypeDelete?AccountDebitTypeID=" + AccountDebitTypeID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	FineTypeCDInUse(parms: FineTypeInUseRequest) {
		var postResult$ = new Subject();
		var url = "SchoolSetupCalendar/FineTypeCDInUse";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	FineTypeDescInUse(parms: FineTypeInUseRequest) {
		var postResult$ = new Subject();
		var url = "SchoolSetupCalendar/FineTypeDescInUse";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}
}
